window.$ = window.jQuery = require('jquery');

function Player($ctr, autoplay, conControles) {
    if (typeof YT === 'undefined') {

        if (window.youtubeScriptInsertado === false) {
            var tag = document.createElement('script');
            // Agrega el atributo defer para que el script se ejecute después de que la página se cargue
            tag.defer = true;
            // Agrega el atributo async para que el script se ejecute de forma asíncrona
            tag.async = true;
            tag.src = "//www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            window.youtubeScriptInsertado = true;
        }

        window.onYouTubeIframeAPIReady = function () {
            $("body").trigger("youtube-ready")
        }
    }

    if (typeof autoplay === 'undefined') {
        autoplay = true;
    }

    if (typeof conControles === 'undefined') {
        conControles = true;
    }

    let player, duracion, tempo;
    let codigo = $ctr.attr("data-codigo");
    let mascara = $ctr.attr("data-mascara");
    let id = Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    let arrancarMonitor = function() {

        tempo = setInterval(function () {
            // var v = player.getCurrentTime();
            var posX = player.getCurrentTime() / duracion * 100;
            $ctr.find(".ctrol-track").css("width", posX + "%");
        }, 100);
    };
    let pararMonitor = function() {

        clearInterval(tempo);
    };
    let htmlControles = '';
    if (conControles) {
        htmlControles = '<div class="controles">' +
            '                    <div class="track">' +
            '                        <div class="ctrol-track"></div>' +
            '                    </div>' +
            '                    <div class="playing"><i class="fa fa-play"></i></div>' +
            '                    <div class="mute"><i class="fa fa-volume-off"></i></div>' +
            '                </div>';
    }
    let htmlMascara = '';

    if (mascara) {
        // A partir de la url de la imagen con extension png, se genera la url de la imagen con extension webp
        let mascaraWebp = mascara.replace(".png", ".webp");
        htmlMascara = `<div class="player-mascara">
            <picture>
                <source srcset="${mascaraWebp}" type="image/webp" width="1200" height="675" >
                <img src="${mascara}" alt="JaponShop" width="1200" height="675" \>
            </picture>
        </div>`;
    }

    let html = `<div class="player-video"><div id="${id}" class="video"></div>${htmlMascara}${htmlControles}</div>`;


    $ctr.html(html);

    $("body").on("youtube-ready", function () {
        player = new YT.Player(id, {
            videoId: codigo,
            playerVars: {
                controls: 0,
                rel: 0,
                showinfo: 0,
                wmode: 'transparent',
                enablejsapi: 1
            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });
    });
    var ejecutarPlay = false;
    var playerListo = false;
    function onPlayerReady(event) {
        playerListo = true;
        if (autoplay === true || ejecutarPlay === true) {
            event.target.playVideo();
        }
        event.target.mute();
    }

    function onPlayerStateChange(event) {
        if (conControles) {
            switch (event.data) {
                case -1:
                    //unstarted, sin empezar
                    break;
                case 0:
                    //ended, finalizado
                    $ctr.find(".playing").html('<i class="fa fa-play"></i>');
                    $ctr.trigger("video-finalizado");
                    break;
                case 1:
                    //playing, en reproducción
                    duracion = player.getDuration();
                    arrancarMonitor();
                    $ctr.find(".playing").html('<i class="fa fa-pause"></i>');
                    break;
                case 2:
                    //paused, en pausa
                    $ctr.find(".playing").html('<i class="fa fa-play"></i>');
                    pararMonitor();
                    break;
                case 3:
                    //almacenando en búfer
                    break;
                case 5:
                    //video cued, video en cola
                    break;
                default:
            }
        } else {
            switch (event.data) {
                case -1:
                    //unstarted, sin empezar
                    break;
                case 0:
                    //ended, finalizado
                    $ctr.trigger("video-finalizado");
                    break;
                case 3:
                    //almacenando en búfer
                    break;
                case 5:
                    //video cued, video en cola
                    break;
                default:
            }
        }

    }

    if (conControles) {
        $ctr.on("click", ".playing", function () {
            var estado = player.getPlayerState();
            switch (estado) {
                case 0:
                    //              player.seekTo(0, true);
                    break;
                case 1:
                    player.pauseVideo();
                    break;
                case -1:
                case 2:
                    player.playVideo();
                    break;
                case 5:
                    player.playVideo();
                    break;
                default:

            }
        });

        $ctr.on("click", ".mute", function () {
            var isMuted = player.isMuted();

            if (isMuted) {
                player.unMute();
                $(this).html('<i class="fa fa-volume-up"></i>');
            } else {
                player.mute();
                $(this).html('<i class="fa fa-volume-off"></i>');
            }
        });

        $ctr.on("click", ".track", function(e) {
            duracion = player.getDuration();
            var anchoTrack = $(this).width();
            if (duracion !== 0) {
                var offset = $(this).offset();
                var segundos = (e.clientX - offset.left) / anchoTrack * duracion;
                player.seekTo(segundos, true);
                var posX = segundos / duracion * 100;
                $(this).find(".ctrol-track").css("width", posX + "%");
            }
        });
    }

    this.cargar = function (codigo) {
        player.loadVideoById(codigo);
    }

    this.replay = function () {
        if (playerListo) {
            player.playVideo();
        } else {
            $ctr.trigger("video-finalizado");
        }
    }

    this.parar = function () {
        player.pauseVideo();
        player.seekTo(0, true);
    }

    this.playEnListo = function () {
        if (playerListo) {
            player.playVideo();
        } else {
            ejecutarPlay = true;
        }
    }

    this.getId = function() {
        return id;
    }
}

export default Player;

